// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.case-studies-container {
    padding: 20px;
    padding-top: 0;
    text-align: center;
}

.case-studies-container h2 {
    margin-bottom: 20px;
    font-size: 2rem;
}

.thumbnail {
    cursor: pointer;
    overflow: hidden;
    width: 80%; /* Full width for responsiveness */
    margin: 10px 20px;
    border-radius: 8px;
    box-shadow: 4px 4px 18px rgba(0, 0, 0, 0.2);
}

.thumbnail img {
    width: 100%;
    height: auto;
    display: block;
}
.modal-overlay-canva {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 999;
}

.modal-content-canva {
    position: relative;
    background: transparent;
    border-radius: 8px;
    width: 90vw;
    height: 80vh; /* Adjust height */
    border: none;
}

.modal-close {
    position: absolute;
    top: 10px;
    right: 10px;
    color: aliceblue;
    background: transparent;
    border: none;
    font-size: 24px;
    cursor: pointer;
}

.slider-container {
    position: relative;
    margin-bottom: 20px;
}

.slider-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: 50%;
    background: rgba(255, 255, 255, 0.7);
    border: none;
    border-radius: 50%;
    padding: 5px;
    cursor: pointer;
    z-index: 10;
    transform: translateY(-50%);
}

.prev-btn {
    left: 10px;
}

.next-btn {
    right: 10px;
}

.slider-btn svg {
    width: 20px;
    height: 20px;
}

.view-more-button {
    font-size: 16px;
    font-weight: 500;
    border-radius: 10px;
    padding: 5px 10px;
    cursor: pointer;
    color: white;
    box-shadow: none;
    background-color: rgb(0, 0, 0);
}

/* Media query adjustments */
@media (max-width: 768px) {
    /* .thumbnail {
        width: 80vw; 
    } */
}
`, "",{"version":3,"sources":["webpack://./src/BA/CaseStudies.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,UAAU,EAAE,kCAAkC;IAC9C,iBAAiB;IACjB,kBAAkB;IAClB,2CAA2C;AAC/C;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,cAAc;AAClB;AACA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,8BAA8B;IAC9B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,uBAAuB;IACvB,kBAAkB;IAClB,WAAW;IACX,YAAY,EAAE,kBAAkB;IAChC,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,gBAAgB;IAChB,uBAAuB;IACvB,YAAY;IACZ,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,QAAQ;IACR,oCAAoC;IACpC,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,WAAW;IACX,2BAA2B;AAC/B;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;IACjB,eAAe;IACf,YAAY;IACZ,gBAAgB;IAChB,8BAA8B;AAClC;;AAEA,4BAA4B;AAC5B;IACI;;OAEG;AACP","sourcesContent":[".case-studies-container {\n    padding: 20px;\n    padding-top: 0;\n    text-align: center;\n}\n\n.case-studies-container h2 {\n    margin-bottom: 20px;\n    font-size: 2rem;\n}\n\n.thumbnail {\n    cursor: pointer;\n    overflow: hidden;\n    width: 80%; /* Full width for responsiveness */\n    margin: 10px 20px;\n    border-radius: 8px;\n    box-shadow: 4px 4px 18px rgba(0, 0, 0, 0.2);\n}\n\n.thumbnail img {\n    width: 100%;\n    height: auto;\n    display: block;\n}\n.modal-overlay-canva {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background: rgba(0, 0, 0, 0.5);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 999;\n}\n\n.modal-content-canva {\n    position: relative;\n    background: transparent;\n    border-radius: 8px;\n    width: 90vw;\n    height: 80vh; /* Adjust height */\n    border: none;\n}\n\n.modal-close {\n    position: absolute;\n    top: 10px;\n    right: 10px;\n    color: aliceblue;\n    background: transparent;\n    border: none;\n    font-size: 24px;\n    cursor: pointer;\n}\n\n.slider-container {\n    position: relative;\n    margin-bottom: 20px;\n}\n\n.slider-btn {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    position: absolute;\n    top: 50%;\n    background: rgba(255, 255, 255, 0.7);\n    border: none;\n    border-radius: 50%;\n    padding: 5px;\n    cursor: pointer;\n    z-index: 10;\n    transform: translateY(-50%);\n}\n\n.prev-btn {\n    left: 10px;\n}\n\n.next-btn {\n    right: 10px;\n}\n\n.slider-btn svg {\n    width: 20px;\n    height: 20px;\n}\n\n.view-more-button {\n    font-size: 16px;\n    font-weight: 500;\n    border-radius: 10px;\n    padding: 5px 10px;\n    cursor: pointer;\n    color: white;\n    box-shadow: none;\n    background-color: rgb(0, 0, 0);\n}\n\n/* Media query adjustments */\n@media (max-width: 768px) {\n    /* .thumbnail {\n        width: 80vw; \n    } */\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
